export default __webpack_public_path__ + "static/media/Trend6.7c8edd81.svg";